module.exports = __webpack_public_path__ + "static/media/016-boy-2.9bc05bad.svg";